import { CreateNotification } from "../components/notifier";
import { Environment } from "../constants";
import { checkLoggingStatus } from "../constants/statusConstants";
import { SET_EXPIRED_TOKEN_ERROR } from "../services/main/main.reducer";
import { store } from "../store/store";

const openUrl = (url: string) => {
  window.open(url, "_blank");
};

const showDocumentPerrmissionAccessDenied = () => {
  CreateNotification({
    title: "Thông báo",
    body: `Bạn không có quyền truy cập tài liệu. Vui lòng liên hệ Admin để hỗ trợ.`,
    icon: "/icons/error.png",
  });
};

const getLookupData = (lookupData: any, namespace: any) => {
  return lookupData?.filter((f: any) => f.Namespace === namespace)?.map((l: any) => ({ value: l.Id, label: l.Title }));
};

const checkExpiredToken = (account: any) => {
  const currentDate = new Date();
  if (account?.expiresOn && account?.expiresOn < currentDate) {
    return true;
  }

  return false;
};

const checkingAcessToken = (user: any, mainState: any) => {
  if (!user) return checkLoggingStatus.NotLoggedIn;

  if (mainState.isUnauthorized) return checkLoggingStatus.Unauthorized;

  if (mainState.isExpiredToken) return checkLoggingStatus.ExpiredToken;

  if (checkExpiredToken(user)) {
    store.dispatch({
      type: SET_EXPIRED_TOKEN_ERROR,
      status: true,
    });
    return checkLoggingStatus.ExpiredToken;
  }

  return checkLoggingStatus.OK;
};

const getRandomColor = (str: string) => {
  if (!str) return "#32F4F4";
  let hash = Array.from(str).reduce((acc, char) => {
    return char.charCodeAt(0) + ((acc << 5) - acc);
  }, 0);

  let color = "#";
  for (let j = 0; j < 3; j++) {
    const value = (hash >> (j * 8)) & 0xff;
    color += value.toString(16).padStart(2, "0");
  }

  return color;
};

export {
  openUrl,
  showDocumentPerrmissionAccessDenied,
  getLookupData,
  checkExpiredToken,
  checkingAcessToken,
  getRandomColor,
};

export const getAppEnv = () => process.env.REACT_APP_ENV as Environment;

export const isProduction = getAppEnv() === Environment.production;